"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const CharacterCount = ({ text, max }) => {
    const characterCount = (text === null || text === void 0 ? void 0 : text.toString().length) || 0;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('_text-1 _text-gray-500 _text-right', {
            '_text-red _font-weight-bold': characterCount >= max
        }), children: `${characterCount}/${max}` }));
};
exports.default = CharacterCount;
